import React from 'react';
var FormLabel = function (props) {
    return (React.createElement("label", { style: { marginBottom: 16 } },
        React.createElement("h4", null, props.children)));
};
export default FormLabel;
